import React from "react";
import styled from "styled-components";
import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

const IconCard = ({icon, number, label}) => {
  return (
    <StatItem>
      <IconWrapper>
        <StatIcon
          src={icon}
          alt={`${label} Icon`}
          width={320}
          height={320}
          sizes="(max-width: 768px) 11rem, 16rem"
          loading="lazy"
          decoding="async"
        />
      </IconWrapper>
      <StatText>
        <StatNumber>{number}</StatNumber>
        <StatLabel>{label}</StatLabel>
      </StatText>
    </StatItem>
  );
};

const StatsSection = ({data = []}) => {
  return (
    <Section>
      <Container>
        <StatsWrapper>
          {data.map((stat) => (
            <IconCard
              key={stat.id}
              icon={stat.icon}
              number={stat.number}
              label={stat.label}
            />
          ))}
        </StatsWrapper>
      </Container>
    </Section>
  );
};

const Section = styled.div`
  width: 100%;
  background: ${colors.white};
  margin-bottom: 10rem;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 0;
    margin-bottom: 5.6rem;
  }
`;

const Container = styled.div`
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  padding: 0 2rem;
  
`;

const StatsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem;
  align-items: center;
  justify-items: center;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
  }

`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16rem;
  height: 16rem;

  @media (max-width: 768px) {
    width: 11rem;
    height: 11rem;
  }
`;

const StatIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const StatText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;

  @media(max-width: 768px) {
    flex-direction: column;
  }
`;

const StatNumber = styled.span`
  font-family: 'Lato';
  font-size: 2rem;
  font-weight: 700;
  color: ${colors.textBlack};
  margin: 0;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 1.8rem;
    font-weight: 500;
  }

`;

const StatLabel = styled.p`
  font-family: 'Lato';
  font-size: 2rem;
  font-weight: 400;
  color:${colors.textBlack};
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;
export default StatsSection;